export const left = [
  {
    text: "Friends",
    img: "friends",
    to: "friends",
  },
  {
    text: "Groups",
    img: "groups",
    to: "/groups",
  },
  {
    text: "Messenger",
    img: "messenger",
    to: "/messages",
  },
  {
    text: "Saved",
    img: "saved",
    to: "/saved",
  },
];
export const stories = [
  {
    profile_picture: "../../stories/profile1.jpg",
    profile_name: "Elon Musk",
    image: "../../stories/1.jpg",
  },
  {
    profile_picture: "../../stories/profile2.jpg",
    profile_name: "South park",
    image: "../../stories/2.png",
  },
  {
    profile_picture: "../../stories/profile3.png",
    profile_name: "The Sopranos",
    image: "../../stories/3.jpg",
  },
  {
    profile_picture: "../../stories/profile4.jfif",
    profile_name: "Football World",
    image: "../../stories/4.jpg",
  },
  {
    profile_picture: "../../stories/profile5.png",
    profile_name: "The Witcher Wild Hunt",
    image: "../../stories/5.jfif",
  },
  {
    profile_picture: "../../stories/profile4.jfif",
    profile_name: "Football World",
    image: "../../stories/4.jpg",
  },
  {
    profile_picture: "../../stories/profile5.png",
    profile_name: "The Witcher Wild Hunt",
    image: "../../stories/5.jfif",
  },
];
